import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Table = React.forwardRef(
  function Table2({ className, ...props }, ref) {
    return /* @__PURE__ */ jsx("table", { ref, className: cn("w-full text-sm", className), ...props });
  }
);
var TableHeader = React.forwardRef(function TableHeader2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx("thead", { ref, className: cn("border-b bg-muted/40 text-left", className), ...props });
});
var TableBody = React.forwardRef(function TableBody2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx("tbody", { ref, className, ...props });
});
var TableFooter = React.forwardRef(function TableFooter2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx("tfoot", { ref, className: cn("border-t bg-muted/40 font-medium", className), ...props });
});
var TableRow = React.forwardRef(function TableRow2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx("tr", { ref, className: cn("border-b last:border-0", className), ...props });
});
var TableHead = React.forwardRef(function TableHead2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    "th",
    {
      ref,
      className: cn("px-3 py-2 text-left font-medium text-muted-foreground", className),
      ...props
    }
  );
});
var TableCell = React.forwardRef(function TableCell2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx("td", { ref, className: cn("px-3 py-2 align-middle", className), ...props });
});
var TableCaption = React.forwardRef(function TableCaption2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx("caption", { ref, className: cn("mt-2 text-xs text-muted-foreground", className), ...props });
});

export { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow };
//# sourceMappingURL=chunk-PEIGN6MO.js.map
//# sourceMappingURL=chunk-PEIGN6MO.js.map